import { t } from 'i18next';
import React from 'react';
import { KeyValuePair } from '../CommonTypes';
import { PaymentMethod } from '../Constants';
import { getPaymentMethodDisplayName } from '../HelperMethods';
import PaymentMethodButton from './PaymentMethodButton';

type PaymentMethodsProps = {
  productTypeId: number;
  paymentMethods: string[];
  selectedPaymentMethod: string;
  selectedCoverLevel: number | undefined;
  selectedClaimLimit: number | undefined;
  hasError: boolean;
  onPaymentMethodClick: (paymentMethod: string) => void;
};

const PaymentMethods = ({
  productTypeId,
  paymentMethods,
  selectedPaymentMethod,
  selectedCoverLevel,
  selectedClaimLimit,
  hasError,
  onPaymentMethodClick
}: PaymentMethodsProps): JSX.Element => {
  const paymentMethodDisplayNames: KeyValuePair[] = [
    {
      key: PaymentMethod.Single,
      value: t('customer-product-page.payment-type.single')
    },
    {
      key: PaymentMethod.Monthly,
      value: t('customer-product-page.payment-type.monthly')
    },
    {
      key: PaymentMethod.Subscription,
      value: t('customer-product-page.payment-type.subscription')
    }
  ];

  return (
    <div
      className={paymentMethods.length > 1 ? 'btn-group w-100' : 'btn-group'}
      role='group'
      aria-label='Payment options'>
      {paymentMethods.map((paymentMethod, i) => {
        const controlId = `paymentmethod-${i}-${productTypeId}`;

        let buttonClass = 'btn';

        if (paymentMethods.length > 1) {
          if (i > 0) {
            buttonClass += ' cms-btn-toggle-last';
          }

          if (i < paymentMethods.length - 1) {
            buttonClass += ' cms-btn-toggle-first';
          }
        }

        const paymentMethodDisplayName = getPaymentMethodDisplayName(
          paymentMethod,
          paymentMethodDisplayNames
        );

        return (
          <PaymentMethodButton
            key={controlId}
            index={i}
            paymentMethod={paymentMethodDisplayName}
            disabled={!(selectedCoverLevel || selectedClaimLimit)}
            selected={paymentMethod === selectedPaymentMethod}
            hasError={hasError}
            onClick={() => onPaymentMethodClick(paymentMethod)}
            className={buttonClass}
          />
        );
      })}
    </div>
  );
};

export default PaymentMethods;
